// promiseAlmost receives list of promises and returns the list of resolved and rejected promises
// unlike Promise.all which will throw an error if one of the promise is rejected
// eslint-disable-next-line import/prefer-default-export
export const promiseAlmost = r => Promise.all(r.map(p => (p && p.catch ? p.catch(e => e) : p)));
